import { jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { optimizeResponsiveArray } from "../../utils/optimizeResponsiveArray.mjs";
import { Box } from "../Box/Box.mjs";
import { ColumnsContext } from "../Columns/ColumnsContext.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { column, width, columnContent } from "./Column.css.mjs";
const Column = ({ children, data, width: width$1, ...restProps }) => {
  const {
    collapseMobile,
    collapseTablet,
    collapseDesktop,
    mobileSpace,
    tabletSpace,
    desktopSpace,
    wideSpace,
    collapsibleAlignmentChildProps,
    component
  } = useContext(ColumnsContext);
  return /* @__PURE__ */ jsx(
    Box,
    {
      component,
      display: component === "span" ? "block" : void 0,
      minWidth: 0,
      width: width$1 !== "content" ? "full" : void 0,
      flexShrink: width$1 === "content" ? 0 : void 0,
      className: [column, width$1 !== "content" ? width[width$1] : null],
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children: /* @__PURE__ */ jsx(
        Box,
        {
          component,
          paddingLeft: optimizeResponsiveArray([
            collapseMobile ? "none" : mobileSpace,
            collapseTablet ? "none" : tabletSpace,
            collapseDesktop ? "none" : desktopSpace,
            wideSpace
          ]),
          paddingTop: collapseMobile || collapseTablet || collapseDesktop ? optimizeResponsiveArray([
            collapseMobile ? mobileSpace : "none",
            collapseTablet ? tabletSpace : "none",
            collapseDesktop ? desktopSpace : "none",
            "none"
          ]) : void 0,
          height: "full",
          ...collapsibleAlignmentChildProps,
          className: columnContent,
          children
        }
      )
    }
  );
};
export {
  Column
};
